import { ValidatorFn, AbstractControl } from '@angular/forms';
import Swal from 'sweetalert2';

export const CustomInteger = (type: any): ValidatorFn => {

  const error = {
    invalidInteger: true,
    message: 'This value is should be integer'
  };

  return (control: AbstractControl): any => {

    try {

      if (!control.value) {
        return null;
      }

      if (typeof type === 'string') {
        type = type.toLocaleLowerCase();
        type = type.split(',');
      }

      if (new RegExp('^[0-9]+$', 'gm').test(control.value)) {
        return null;
      } else {

        if (type[0] === 'warning') {
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: true
          });

          Toast({
            type: 'warning',
            title: `This filed "${type[1] && type[1]}" is should be integer`
          });

          return null;
        } else {
          return error;
        }

      }

    } catch (error) {
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/components/integer/integer-validator.ts